import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { leaveOnlineBookingWaitlistThunk } from 'actions/onlineBooking/actions/OnlineBookingWaitlistActions';
import { dogHighFive, heroGirlCombingDog } from 'assets/images';
import clsx from 'clsx';
import { PoweredByCuddles } from 'components/Cuddles/PoweredBy/PoweredByCuddles';
import { LeftColumn } from 'components/Layout/TwoColumns/LeftColumn/LeftColumn';
import { RightImageColumn } from 'components/Layout/TwoColumns/RightImageColumn/RightImageColumn';
import { TwoColumnsLayout } from 'components/Layout/TwoColumns/TwoColumnsLayout';
import { OnlineBookingHeader } from 'components/OnlineBooking/Header/OnlineBookingHeader';
import { Button } from 'components/UI/Button/Button';
import React from 'react';
import { useSelector } from 'react-redux';
import { getMarketplace } from 'reducers/marketplace/MarketplaceSelectors';
import { dispatch } from 'store';
import { goToPetParentPortal } from 'utils/petParentPortal';
import classes from './OnlineBookingWaitlistSuccessStep.module.scss';

export const OnlineBookingWaitlistSuccessStep: React.FC = () => {
    const { slug, onlineBookingPreferences: olbPreferences } = useSelector(getMarketplace);

    return (
        <TwoColumnsLayout header={<OnlineBookingHeader />}>
            <LeftColumn contentClassName={classes.content}>
                <FontAwesomeIcon icon={faCircleCheck} className={classes.icon} />

                <h1 className={clsx('h1', classes.title)}>You&apos;re on the waitlist!</h1>

                <p className={classes.description}>
                    We&apos;ll let you know if a spot opens up for your preferred date and time.
                </p>

                <Button
                    className={classes.primaryAction}
                    onClick={() => dispatch(leaveOnlineBookingWaitlistThunk())}
                >
                    Go Back to Online Booking
                </Button>

                <Button
                    className={classes.portalLink}
                    variant="underlined-link"
                    onClick={() => goToPetParentPortal(slug)}
                >
                    Go to Pet Parent Portal
                </Button>

                <div>
                    <PoweredByCuddles />
                </div>

                <img src={dogHighFive} alt="Dog high five" className={classes.dogImage} />
            </LeftColumn>

            <RightImageColumn image={olbPreferences.promoImageUrl ?? heroGirlCombingDog} />
        </TwoColumnsLayout>
    );
};
